import { CraftedItem } from 'common/ITEMS/Item';

const gems = {
  COGNITIVE_HELIOTROPE: {
    id: 241143,
    name: 'Cognitive Heliotrope',
    icon: 'inv_misc_epicgem_01',
    craftQuality: 1,
  },
  DEADLY_AMETHYST_R1: {
    id: 240865,
    name: 'Deadly Amethyst',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_fire_purple',
    craftQuality: 1,
  },
  DEADLY_AMETHYST_R2: {
    id: 240866,
    name: 'Deadly Amethyst',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_fire_purple',
    craftQuality: 2,
  },
  DEADLY_GARNET_R1: {
    id: 240871,
    name: 'Deadly Garnet',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_fire_red',
    craftQuality: 1,
  },
  DEADLY_GARNET_R2: {
    id: 240872,
    name: 'Deadly Garnet',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_fire_red',
    craftQuality: 2,
  },
  DEADLY_LAPIS_R1: {
    id: 240881,
    name: 'Deadly Lapis',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_fire_blue',
    craftQuality: 1,
  },
  DEADLY_LAPIS_R2: {
    id: 240882,
    name: 'Deadly Lapis',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_fire_blue',
    craftQuality: 2,
  },
  DEADLY_PERIDOT_R1: {
    id: 240857,
    name: 'Deadly Peridot',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_fire_green',
    craftQuality: 1,
  },
  DEADLY_PERIDOT_R2: {
    id: 240858,
    name: 'Deadly Peridot',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_fire_green',
    craftQuality: 2,
  },
  DETERMINED_HELIOTROPE: {
    id: 241142,
    name: 'Determined Heliotrope',
    icon: 'inv_misc_epicgem_uncut_01',
    craftQuality: 1,
  },
  ENDURING_HELIOTROPE: {
    id: 241144,
    name: 'Enduring Heliotrope',
    icon: 'inv_misc_cutgemsuperior6',
    craftQuality: 1,
  },
  FLAWLESS_DEADLY_AMETHYST_R1: {
    id: 240897,
    name: 'Flawless Deadly Amethyst',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_fire_purple',
    craftQuality: 1,
  },
  FLAWLESS_DEADLY_AMETHYST_R2: {
    id: 240898,
    name: 'Flawless Deadly Amethyst',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_fire_purple',
    craftQuality: 2,
  },
  FLAWLESS_DEADLY_GARNET_R1: {
    id: 240903,
    name: 'Flawless Deadly Garnet',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_fire_red',
    craftQuality: 1,
  },
  FLAWLESS_DEADLY_GARNET_R2: {
    id: 240904,
    name: 'Flawless Deadly Garnet',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_fire_red',
    craftQuality: 2,
  },
  FLAWLESS_DEADLY_LAPIS_R1: {
    id: 240913,
    name: 'Flawless Deadly Lapis',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_fire_blue',
    craftQuality: 1,
  },
  FLAWLESS_DEADLY_LAPIS_R2: {
    id: 240914,
    name: 'Flawless Deadly Lapis',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_fire_blue',
    craftQuality: 2,
  },
  FLAWLESS_DEADLY_PERIDOT_R1: {
    id: 240889,
    name: 'Flawless Deadly Peridot',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_fire_green',
    craftQuality: 1,
  },
  FLAWLESS_DEADLY_PERIDOT_R2: {
    id: 240890,
    name: 'Flawless Deadly Peridot',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_fire_green',
    craftQuality: 2,
  },
  FLAWLESS_MASTERFUL_AMETHYST_R1: {
    id: 240895,
    name: 'Flawless Masterful Amethyst',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_void_purple',
    craftQuality: 1,
  },
  FLAWLESS_MASTERFUL_AMETHYST_R2: {
    id: 240896,
    name: 'Flawless Masterful Amethyst',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_void_purple',
    craftQuality: 2,
  },
  FLAWLESS_MASTERFUL_GARNET_R1: {
    id: 240907,
    name: 'Flawless Masterful Garnet',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_void_red',
    craftQuality: 1,
  },
  FLAWLESS_MASTERFUL_GARNET_R2: {
    id: 240908,
    name: 'Flawless Masterful Garnet',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_void_red',
    craftQuality: 2,
  },
  FLAWLESS_MASTERFUL_LAPIS_R1: {
    id: 240917,
    name: 'Flawless Masterful Lapis',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_void_blue',
    craftQuality: 1,
  },
  FLAWLESS_MASTERFUL_LAPIS_R2: {
    id: 240918,
    name: 'Flawless Masterful Lapis',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_void_blue',
    craftQuality: 2,
  },
  FLAWLESS_MASTERFUL_PERIDOT_R1: {
    id: 240891,
    name: 'Flawless Masterful Peridot',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_void_green',
    craftQuality: 1,
  },
  FLAWLESS_MASTERFUL_PERIDOT_R2: {
    id: 240892,
    name: 'Flawless Masterful Peridot',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_void_green',
    craftQuality: 2,
  },
  FLAWLESS_QUICK_AMETHYST_R1: {
    id: 240899,
    name: 'Flawless Quick Amethyst',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_nature_purple',
    craftQuality: 1,
  },
  FLAWLESS_QUICK_AMETHYST_R2: {
    id: 240900,
    name: 'Flawless Quick Amethyst',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_nature_purple',
    craftQuality: 2,
  },
  FLAWLESS_QUICK_GARNET_R1: {
    id: 240905,
    name: 'Flawless Quick Garnet',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_nature_red',
    craftQuality: 1,
  },
  FLAWLESS_QUICK_GARNET_R2: {
    id: 240906,
    name: 'Flawless Quick Garnet',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_nature_red',
    craftQuality: 2,
  },
  FLAWLESS_QUICK_LAPIS_R1: {
    id: 240915,
    name: 'Flawless Quick Lapis',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_nature_blue',
    craftQuality: 1,
  },
  FLAWLESS_QUICK_LAPIS_R2: {
    id: 240916,
    name: 'Flawless Quick Lapis',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_nature_blue',
    craftQuality: 2,
  },
  FLAWLESS_QUICK_PERIDOT_R1: {
    id: 240887,
    name: 'Flawless Quick Peridot',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_nature_green',
    craftQuality: 1,
  },
  FLAWLESS_QUICK_PERIDOT_R2: {
    id: 240888,
    name: 'Flawless Quick Peridot',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_nature_green',
    craftQuality: 2,
  },
  FLAWLESS_VERSATILE_AMETHYST_R1: {
    id: 240901,
    name: 'Flawless Versatile Amethyst',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_frost_purple',
    craftQuality: 1,
  },
  FLAWLESS_VERSATILE_AMETHYST_R2: {
    id: 240902,
    name: 'Flawless Versatile Amethyst',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_frost_purple',
    craftQuality: 2,
  },
  FLAWLESS_VERSATILE_GARNET_R1: {
    id: 240909,
    name: 'Flawless Versatile Garnet',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_frost_red',
    craftQuality: 1,
  },
  FLAWLESS_VERSATILE_GARNET_R2: {
    id: 240910,
    name: 'Flawless Versatile Garnet',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_frost_red',
    craftQuality: 2,
  },
  FLAWLESS_VERSATILE_LAPIS_R1: {
    id: 240911,
    name: 'Flawless Versatile Lapis',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_frost_blue',
    craftQuality: 1,
  },
  FLAWLESS_VERSATILE_LAPIS_R2: {
    id: 240912,
    name: 'Flawless Versatile Lapis',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_frost_blue',
    craftQuality: 2,
  },
  FLAWLESS_VERSATILE_PERIDOT_R1: {
    id: 240893,
    name: 'Flawless Versatile Peridot',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_frost_green',
    craftQuality: 1,
  },
  FLAWLESS_VERSATILE_PERIDOT_R2: {
    id: 240894,
    name: 'Flawless Versatile Peridot',
    icon: 'inv_12_profession_jewelcrafting_rare_gem_cut_frost_green',
    craftQuality: 2,
  },
  INDECIPHERABLE_EVERSONG_DIAMOND_R1: {
    id: 240982,
    name: 'Indecipherable Eversong Diamond',
    icon: 'inv_12_profession_jewelcrafting_epic_gem_cut_green',
    craftQuality: 1,
  },
  INDECIPHERABLE_EVERSONG_DIAMOND_R2: {
    id: 240983,
    name: 'Indecipherable Eversong Diamond',
    icon: 'inv_12_profession_jewelcrafting_epic_gem_cut_green',
    craftQuality: 2,
  },
  MASTERFUL_AMETHYST_R1: {
    id: 240863,
    name: 'Masterful Amethyst',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_void_purple',
    craftQuality: 1,
  },
  MASTERFUL_AMETHYST_R2: {
    id: 240864,
    name: 'Masterful Amethyst',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_void_purple',
    craftQuality: 2,
  },
  MASTERFUL_GARNET_R1: {
    id: 240875,
    name: 'Masterful Garnet',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_void_red',
    craftQuality: 1,
  },
  MASTERFUL_GARNET_R2: {
    id: 240876,
    name: 'Masterful Garnet',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_void_red',
    craftQuality: 2,
  },
  MASTERFUL_LAPIS_R1: {
    id: 240885,
    name: 'Masterful Lapis',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_void_blue',
    craftQuality: 1,
  },
  MASTERFUL_LAPIS_R2: {
    id: 240886,
    name: 'Masterful Lapis',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_void_blue',
    craftQuality: 2,
  },
  MASTERFUL_PERIDOT_R1: {
    id: 240859,
    name: 'Masterful Peridot',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_void_green',
    craftQuality: 1,
  },
  MASTERFUL_PERIDOT_R2: {
    id: 240860,
    name: 'Masterful Peridot',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_void_green',
    craftQuality: 2,
  },
  POWERFUL_EVERSONG_DIAMOND_R2: {
    id: 240967,
    name: 'Powerful Eversong Diamond',
    icon: 'inv_12_profession_jewelcrafting_epic_gem_cut_orange',
    craftQuality: 2,
  },
  POWERFUL_EVERSONG_DIAMOND_R1: {
    id: 240966,
    name: 'Powerful Eversong Diamond',
    icon: 'inv_12_profession_jewelcrafting_epic_gem_cut_orange',
    craftQuality: 1,
  },
  QUICK_AMETHYST_R1: {
    id: 240867,
    name: 'Quick Amethyst',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_nature_purple',
    craftQuality: 1,
  },
  QUICK_AMETHYST_R2: {
    id: 240868,
    name: 'Quick Amethyst',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_nature_purple',
    craftQuality: 2,
  },
  QUICK_GARNET_R1: {
    id: 240873,
    name: 'Quick Garnet',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_nature_red',
    craftQuality: 1,
  },
  QUICK_GARNET_R2: {
    id: 240874,
    name: 'Quick Garnet',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_nature_red',
    craftQuality: 2,
  },
  QUICK_LAPIS_R1: {
    id: 240883,
    name: 'Quick Lapis',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_nature_blue',
    craftQuality: 1,
  },
  QUICK_LAPIS_R2: {
    id: 240884,
    name: 'Quick Lapis',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_nature_blue',
    craftQuality: 2,
  },
  QUICK_PERIDOT_R1: {
    id: 240855,
    name: 'Quick Peridot',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_nature_green',
    craftQuality: 1,
  },
  QUICK_PERIDOT_R2: {
    id: 240856,
    name: 'Quick Peridot',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_nature_green',
    craftQuality: 2,
  },
  STOIC_EVERSONG_DIAMOND_R1: {
    id: 240970,
    name: 'Stoic Eversong Diamond',
    icon: 'inv_12_profession_jewelcrafting_epic_gem_cut_pink',
    craftQuality: 1,
  },
  STOIC_EVERSONG_DIAMOND_R2: {
    id: 240971,
    name: 'Stoic Eversong Diamond',
    icon: 'inv_12_profession_jewelcrafting_epic_gem_cut_pink',
    craftQuality: 2,
  },
  TELLURIC_EVERSONG_DIAMOND_R2: {
    id: 240969,
    name: 'Telluric Eversong Diamond',
    icon: 'inv_12_profession_jewelcrafting_epic_gem_cut_blue',
    craftQuality: 2,
  },
  TELLURIC_EVERSONG_DIAMOND_R1: {
    id: 240968,
    name: 'Telluric Eversong Diamond',
    icon: 'inv_12_profession_jewelcrafting_epic_gem_cut_blue',
    craftQuality: 1,
  },
  VERSATILE_AMETHYST_R1: {
    id: 240869,
    name: 'Versatile Amethyst',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_frost_purple',
    craftQuality: 1,
  },
  VERSATILE_AMETHYST_R2: {
    id: 240870,
    name: 'Versatile Amethyst',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_frost_purple',
    craftQuality: 2,
  },
  VERSATILE_GARNET_R1: {
    id: 240877,
    name: 'Versatile Garnet',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_frost_red',
    craftQuality: 1,
  },
  VERSATILE_GARNET_R2: {
    id: 240878,
    name: 'Versatile Garnet',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_frost_red',
    craftQuality: 2,
  },
  VERSATILE_LAPIS_R1: {
    id: 240879,
    name: 'Versatile Lapis',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_frost_blue',
    craftQuality: 1,
  },
  VERSATILE_LAPIS_R2: {
    id: 240880,
    name: 'Versatile Lapis',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_frost_blue',
    craftQuality: 2,
  },
  VERSATILE_PERIDOT_R1: {
    id: 240861,
    name: 'Versatile Peridot',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_frost_green',
    craftQuality: 1,
  },
  VERSATILE_PERIDOT_R2: {
    id: 240862,
    name: 'Versatile Peridot',
    icon: 'inv_12_profession_jewelcrafting_uncommon_gem_cut_frost_green',
    craftQuality: 2,
  },
} satisfies Record<string, CraftedItem>;

export default gems;
